import { buttonVariants } from '#/components/ui/button'
import { cn } from '#/lib/utils'

interface OrderOnlineButtonProps {
  /** External ordering URL from site-config. Button renders nothing when empty. */
  url?: string
  className?: string
  label?: string
}

/**
 * Pickup-only online ordering link. Opens the POS-hosted order page in a new
 * tab. Renders nothing when no URL is configured, so it's safe to place before
 * the real link is wired up.
 */
export default function OrderOnlineButton({
  url,
  className,
  label = 'Order Online',
}: OrderOnlineButtonProps) {
  if (!url) return null

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        buttonVariants({ variant: 'default' }),
        'h-11 rounded-full px-6 text-base text-white hover:bg-primary/80',
        className,
      )}
    >
      {label}
    </a>
  )
}
